import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { AppState } from '../lemans-app.model';
import { allocateTrial, getTrialBundles, getTrialReservationInfo, redeemTrial } from './trials.actions';
import { AllocateTrial, RedeemTrial, ReservationInfo } from './trials.model';
import { selectRefreshTrialsGrid, selectTrialBundles, selectTrialReservation } from './trials.selectors';

@Injectable({
  providedIn: 'root',
})
export class TrialsFacade {
  private readonly store$ = inject<Store<AppState>>(Store);

  trialReservation$ = this.store$.select(selectTrialReservation).pipe(filter(Boolean));
  trialBundles$ = this.store$.select(selectTrialBundles);
  refreshTrialsGrid$ = this.store$.select(selectRefreshTrialsGrid);
  getTrialBundles(): void {
    this.store$.dispatch(getTrialBundles());
  }
  getTrialReservationInfo(payload: ReservationInfo): void {
    this.store$.dispatch(getTrialReservationInfo({ payload: payload }));
  }
  redeemTrialReservation(payload: RedeemTrial): void {
    this.store$.dispatch(redeemTrial({ payload: payload }));
  }
  allocateTrial(payload: AllocateTrial): void {
    this.store$.dispatch(allocateTrial({ payload: payload }));
  }
}
